import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { m } from 'framer-motion'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import BlockDataCollectionImage from './BlockDataCollectionImage'

const copy = {
  overline: `Right to object`,
  heading: `Block data collection for specific users with one-click suppression`,
}

const boxes = [
  {
    headline: `Suppress user data collection`,
    content: `Issue suppression requests to restrict user data from being sent to Segment and Cloud-based Destinations.`,
  },
  {
    headline: `Update suppression status at any time`,
    content: `Use the suppression list to easily add or remove users if their preferences change over time.`,
  },
]

const BlockDataCollection: FC<PropsWithChildren<unknown>> = () => {
  return (
    <SectionBase variant="2Col" reverse={true} copyVariant="narrow" sticky={true}>
      <Section.Copy>
        <CopyTextBase>
          <CopyText.Overline tag="h3" variant="h5">
            {copy.overline}
          </CopyText.Overline>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
        </CopyTextBase>
        <ColumnTrackWrapper>
          <ColumnTrack gap="medium">
            {boxes.map(({ headline, content }) => (
              <FeatureBoxBase alignment="left" key={headline}>
                <FeatureBox.Body>
                  <FeatureBox.Title>{headline}</FeatureBox.Title>
                  <FeatureBox.Text>{content}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </ColumnTrackWrapper>
      </Section.Copy>
      <Section.Contents>
        <Section.Sticky>
          <ImageWrapper
            initial={{ opacity: 0 }}
            whileInView={{
              opacity: 1,
              transition: {
                duration: 0.4,
                delay: 0.1,
              },
            }}
            viewport={{ once: true }}
          >
            <BlockDataCollectionImage />
          </ImageWrapper>
        </Section.Sticky>
      </Section.Contents>
    </SectionBase>
  )
}

export default BlockDataCollection

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`

const ImageWrapper = styled(m.div)``
